import { apiUrl, authHeaders } from './auth';

export const fetchCampaignIsForOptions = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/campaignIsFor';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchReferralOptions = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/referralOptions';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchCampaignTypes = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/campaignTypes';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchInjuryTimeFrames = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/injuryTimeFrames';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchMedicalProfessionalTypes = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/medicalProfessionalTypes';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchMedicalExpenseTypes = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/medicalExpenseTypes';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchCommunityTypes = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/communityTypes';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchTermClauses = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/termClauses';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchOtherTermClauses = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/otherTermClauses';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};

export const fetchAgreementTerms = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/options/agreementTerms';
  const resp = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await resp.json();
  return json;
};
